import { Injectable } from "@angular/core";
import { ProductType } from "@obg/ngx.core";

import { ProductMappingConfigService } from "./product-mapping.config";

@Injectable({
	providedIn: "root",
})
export class ProductMappingService {
	constructor(private productMappignConfigService: ProductMappingConfigService) {}

	getMappedProduct(product: ProductType | undefined) {
		const mapping = this.productMappignConfigService.getProductMapping();
		return product ? mapping[product] || product : product;
	}
}
